// tslint:disable: quotemark
export enum ReplenishmentStatusEnum {
	Initialize = 0,
	Processing = 1,
	ProductOrderSent = 2,
	Received = 3,
	Recount = 4,
	Reseal = 5
}

export namespace ReplenishmentStatusEnum {
	export function toDescription(val: ReplenishmentStatusEnum) {
		switch (val) {
			case 0:
				return "Initialize ";
			case 1:
				return "Pending";
			case 2:
				return "Product Order Sent";
			case 3:
				return "Received";
			case 4:
				return "Recount";
			case 5:
				return "Reseal";
		}
		return null;
	}
}
